// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.value .instructions {
  font-size: 14px;
}
.value iframe {
  width: 100%;
  border: 1px solid #ced4da;
  border-radius: 4px;
}
.value .map-container {
  height: 33vh;
  border: 1px solid #ced4da;
  border-radius: 4px;
  width: 100%;
}
.value .map-container eview-map {
  height: 100%;
}

:host {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 1rem 1.25rem 1.25rem;
}

.attr-field {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
  margin: 0;
  padding: 0 0 1.15rem;
}
.attr-field:last-child {
  padding-bottom: 0;
}

.flex-btn-group-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.attr-block {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  width: 100%;
  min-width: 0;
}
.attr-block__label {
  display: block;
  width: 100%;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
  line-height: 1.35;
  margin: 0;
  color: #475569;
  font-weight: 700;
}
.attr-block__value {
  display: block;
  width: 100%;
  min-width: 0;
  margin: 0;
  color: var(--undp-jtf-btn-dark-color, #003d7a);
  font-weight: 400;
  line-height: 1.45;
}
.attr-block__text {
  display: block;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  word-break: break-word;
  font-weight: 400;
}

.vuln-rows-display {
  width: 100%;
  font-weight: 400;
}
.vuln-rows-display__list {
  margin: 0;
  padding-left: 1.25rem;
  list-style: disc;
}
.vuln-rows-display li {
  margin-bottom: 0.25rem;
  line-height: 1.45;
  overflow-wrap: anywhere;
  word-break: break-word;
  font-weight: 400;
}
.vuln-rows-display__sep {
  margin: 0 0.35rem;
  opacity: 0.65;
}
.vuln-rows-display strong {
  font-weight: 600;
}

.flex-btn-group {
  display: flex;
  flex-wrap: wrap;
}
.flex-btn-group .custom-control .custom-control-input:checked ~ .custom-control-label::before {
  background: var(--undp-jtf-btn-dark-color);
  border-color: lightgrey;
}
.flex-btn-group .custom-control .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background: var(--undp-jtf-btn-dark-color);
  border-color: lightgrey;
  opacity: 0.5;
}
.flex-btn-group .custom-control .custom-control-input:not(:disabled):not(:checked):active ~ .custom-control-label::before {
  color: #fff;
  background-color: #fff;
  border-color: lightgrey;
}
.flex-btn-group .custom-control .custom-control-label {
  cursor: pointer;
}

.pad-4 {
  padding: 1% 4%;
}`, "",{"version":3,"sources":["webpack://./apps/hybrid-app/src/app/features/shared/post-viewers/post-map-view/post-map-view.component.scss"],"names":[],"mappings":"AACE;EACE,eAAA;AAAJ;AAEE;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;AAAJ;AAEE;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;AAAJ;AACI;EACE,YAAA;AACN;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,MAAA;EACA,6BAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,oBAAA;AADF;AAGE;EACE,iBAAA;AADJ;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;AAFF;AAIE;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,iBAAA;EACA,SAAA;EACA,cAAA;EACA,gBAAA;AAFJ;AAKE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,8CAAA;EACA,gBAAA;EACA,iBAAA;AAHJ;AAME;EACE,cAAA;EACA,qBAAA;EACA,uBAAA;EACA,sBAAA;EACA,gBAAA;AAJJ;;AAQA;EACE,WAAA;EACA,gBAAA;AALF;AAOE;EACE,SAAA;EACA,qBAAA;EACA,gBAAA;AALJ;AAQE;EACE,sBAAA;EACA,iBAAA;EACA,uBAAA;EACA,sBAAA;EACA,gBAAA;AANJ;AASE;EACE,iBAAA;EACA,aAAA;AAPJ;AAUE;EACE,gBAAA;AARJ;;AAYA;EACE,aAAA;EACA,eAAA;AATF;AAgBY;EACE,0CAAA;EACA,uBARK;AANnB;AAuBc;EACE,0CAAA;EACA,uBAnBG;EAoBH,YAAA;AArBhB;AAgCgB;EACE,WAAA;EACA,sBAAA;EACA,uBAlCC;AAInB;AAsCI;EACE,eAAA;AApCN;;AAyCA;EACE,cAAA;AAtCF","sourcesContent":[".value {\n  .instructions {\n    font-size: 14px;\n  }\n  iframe {\n    width: 100%;\n    border: 1px solid #ced4da;\n    border-radius: 4px;\n  }\n  .map-container {\n    height: 33vh;\n    border: 1px solid #ced4da;\n    border-radius: 4px;\n    width: 100%;\n    eview-map {\n      height: 100%;\n    }\n  }\n}\n\n:host {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  padding: 1rem 1.25rem 1.25rem;\n}\n\n.attr-field {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  min-width: 0;\n  margin: 0;\n  padding: 0 0 1.15rem;\n\n  &:last-child {\n    padding-bottom: 0;\n  }\n}\n\n.flex-btn-group-wrapper {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.attr-block {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n  width: 100%;\n  min-width: 0;\n\n  &__label {\n    display: block;\n    width: 100%;\n    white-space: normal;\n    overflow-wrap: anywhere;\n    word-break: break-word;\n    line-height: 1.35;\n    margin: 0;\n    color: #475569;\n    font-weight: 700;\n  }\n\n  &__value {\n    display: block;\n    width: 100%;\n    min-width: 0;\n    margin: 0;\n    color: var(--undp-jtf-btn-dark-color, #003d7a);\n    font-weight: 400;\n    line-height: 1.45;\n  }\n\n  &__text {\n    display: block;\n    white-space: pre-wrap;\n    overflow-wrap: anywhere;\n    word-break: break-word;\n    font-weight: 400;\n  }\n}\n\n.vuln-rows-display {\n  width: 100%;\n  font-weight: 400;\n\n  &__list {\n    margin: 0;\n    padding-left: 1.25rem;\n    list-style: disc;\n  }\n\n  li {\n    margin-bottom: 0.25rem;\n    line-height: 1.45;\n    overflow-wrap: anywhere;\n    word-break: break-word;\n    font-weight: 400;\n  }\n\n  &__sep {\n    margin: 0 0.35rem;\n    opacity: 0.65;\n  }\n\n  strong {\n    font-weight: 600;\n  }\n}\n\n.flex-btn-group {\n  display: flex;\n  flex-wrap: wrap;\n  $border-color_1: lightgrey;\n  .custom-control {\n    .custom-control-input {\n      &:checked {\n        ~ {\n          .custom-control-label {\n            &::before {\n              background: var(--undp-jtf-btn-dark-color);\n              border-color: $border-color_1;\n            }\n          }\n        }\n      }\n      &:disabled {\n        &:checked {\n          ~ {\n            .custom-control-label {\n              &::before {\n                background: var(--undp-jtf-btn-dark-color);\n                border-color: $border-color_1;\n                opacity: 0.5;\n              }\n            }\n          }\n        }\n      }\n      &:not(:disabled) {\n        &:not(:checked) {\n          &:active {\n            ~ {\n              .custom-control-label {\n                &::before {\n                  color: #fff;\n                  background-color: #fff;\n                  border-color: $border-color_1;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    .custom-control-label {\n      cursor: pointer;\n    }\n  }\n}\n\n.pad-4 {\n  padding: 1% 4%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
